import { Card } from 'antd';

interface CandidateAnswerTextCardProps {
  answerText?: string;
}

const CandidateAnswerTextCard = ({ answerText }: CandidateAnswerTextCardProps) => {
  return <Card>{answerText || ''}</Card>;
};

export default CandidateAnswerTextCard;
